module.exports = __webpack_public_path__ + "img/violet_043.298df16a.png";